import { Component, HostListener, ViewChild } from '@angular/core';
import { CxWindow } from '@app-frame';
import { FavouritesViewList } from '@dashboards-editor';

@Component({
    selector: 'benchmark-favourites-window',
    templateUrl: './benchmark-favourites.template.html',
    standalone: false
})
export class BenchmarkFavouritesWindow {

    @ViewChild(CxWindow, { static: true })
    public window: CxWindow;

    @ViewChild(FavouritesViewList)
    public list: FavouritesViewList;


    public filter: string[];

    public parentContainsViewList(element){
        if(element.tagName && element.tagName.toLowerCase() === 'favourites-view-list'){
            return true;
        }
        if(element.parentNode){
            return this.parentContainsViewList(element.parentNode);
        }
        return false;
    }

    @HostListener('window:click', [ '$event' ])
    public onContainerClick(e){
        const path = e.path || (e.composedPath && e.composedPath());
        if(
            !path.find((current) => {
                return current.classList && current.classList.contains('clx-grid-tile') && this.parentContainsViewList(current);
            })
            && (e.target.tagName && e.target.tagName.toLowerCase() !== 'button')
        ){
            this.list.unselectAll();
            
        }
    }

    public selectAll(){
        this.list.selectAll()
    }

    public ngOnInit(){
        this.filter = ['datapoint'];
    }
}